"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloud_de_de = void 0;
function cloud_de_de() {
    return {
        "cloudpricing.booking.nowforfree": "Jetzt kostenlos buchen",
        "cloudpricing.booking.trial": "14 Tage kostenlos testen",
        "cloudpricing.booking.confirmation.title": "Buchung bestätigen",
        "cloudpricing.booking.confirmation.message": "Hiermit bestätigen Sie die Buchung des folgenden Abonnements:",
        "cloudpricing.booking.confirmation.submessage": "Preise ohne Mwst. Bereits gezahlten Kosten werden anteilig verrechnet.",
        "cloudpricing.booking.confirmation.subnotfound": "Das angegebene Abonnement existiert nicht.",
        "cloudpricing.booking.confirmation.booknow": "Verbindlich buchen",
        "cloudpricing.booking.alreadybooked": "aktuell gebucht",
        "cloudpricing.booking.changeplan": "Jetzt umbuchen",
        "cloudpricing.booking.cancel": "Abo kündigen",
        "cloudpricing.booking.trialuntil": "Testphase bis ",
        "cloudpricing.booking.cancelledat": "Gekündigt zum ",
        "cloudpricing.booking.errors.missingbillingaddress": "Sie müssen Ihrer Firma eine Rechnungsadresse hinzufügen bevor Sie Abonnements buchen können.",
        "cloudpricing.booking.errors.usernotvalidated": "Sie müssen Ihre E-Mail Adresse bestätigen, bevor Sie Abonnements buchen können.",
        "cloudpricing.free": "Kostenlos",
        "cloudpricing.basic": "Basic",
        "cloudpricing.standard": "Standard",
        "cloudpricing.premium": "Premium",
        "cloudpricing.groups.content.title": "Inhalte",
        "cloudpricing.groups.workflows.title": "Workflows",
        "cloudpricing.groups.dashboards.title": "Dashboards",
        "cloudpricing.groups.pim.title": "Produkte & Shops",
        "cloudpricing.groups.applications.title": "Applikationen",
        "cloudpricing.groups.general.title": "Allgemein",
        "cloudpricing.groups.extensions.title": "Erweiterungen",
        "cloudpricing.features.checkin.limits.appamount": "Check-In Apps",
        "cloudpricing.features.optin.limits.amount": "Benutzer Einwilligungen",
        "cloudpricing.features.workflow.title": "Workflows",
        "cloudpricing.features.workflow.limits.amount": "Anzahl",
        "cloudpricing.features.workflow.limits.executionamount": "Ausführungen pro Monat",
        "cloudpricing.features.dashboards.title": "Dashboards",
        "cloudpricing.features.dashboards.limits.amount": "Anzahl",
        "cloudpricing.features.dashboards.limits.widgetamount": "Widgets pro Dashboard",
        "cloudpricing.features.dashboards.limits.layouts": "Layouts",
        "cloudpricing.features.applications.title": "Applikationen",
        "cloudpricing.features.applications.limits.amount": "Anzahl",
        "cloudpricing.features.applications.limits.theme": "Theme",
        "cloudpricing.features.applications.limits.customcss": "Eigenes CSS",
        "cloudpricing.features.applications.limits.customdomains": "Eigene Domains",
        "cloudpricing.features.applications.limits.pwasupport": "Progressive Web App Unterstützung",
        "cloudpricing.features.cms.title": "Inhalte",
        "cloudpricing.features.cms.limits.pageamount": "Seitenanzahl",
        "cloudpricing.features.cms.limits.calendaramount": "Kalender",
        "cloudpricing.features.cms.limits.filestoragegbamount": "Speicherplatz (in GB)",
        "cloudpricing.features.cms.limits.formamount": "Formulare",
        "cloudpricing.features.cms.limits.i18n": "Internationalisierung",
        "cloudpricing.features.cms.limits.optins": "Einwilligungen",
        "cloudpricing.features.cms.limits.blogamount": "Blogs",
        "cloudpricing.features.cms.limits.blogpostamount": "Blog Beiträge",
        "cloudpricing.features.cms.limits.customblogdomain": "Eigene Blog Domain",
        "cloudpricing.features.pim.title": "Online Shop & Produkte",
        "cloudpricing.features.pim.limits.customeramount": "Kunden",
        "cloudpricing.features.pim.limits.productamount": "Produkte",
        "cloudpricing.features.pim.limits.supplieramount": "Zulieferer",
        "cloudpricing.features.pim.limits.productvariants": "Produktvarianten",
        "cloudpricing.features.extension.limits.amount": "Backoffice Erweiterungen",
        "cloudpricing.features.calendar.limits.amount": "Kalender",
        "cloudpricing.features.files.limits.gbamount": "Speicherplatz (in GB)",
        "cloudpricing.features.forms.limits.amount": "Formulare",
        "cloudpricing.features.internationalization.title": "Internationalisierung",
        "cloudpricing.features.products.limits.amount": "Anzahl",
        "cloudpricing.features.products.limits.variants": "Produkt Varianten",
        "cloudpricing.features.users.limits.amount": "Benutzer Anzahl",
        "cloudpricing.features.email.limits.customemailprovider": "Benutzerdefinierter E-Mail Provider",
        "cloudpricing.features.email.limits.templatesamount": "E-Mail Vorlagen",
        "cloudpricing.features.devices.limits.amount": "Externe Geräte",
        "cloudpricing.features.configuration.title": "Konfigurationen",
        "cloudpricing.features.impex.title": "Import / Export",
        "cloudpricing.features.custombackoffices.limits.amount": "Eigene Backoffice Module",
        "cloudpricing.features.custom.limits.datatypeamount": "Benutzerdefinierte Datentypen"
    };
}
exports.cloud_de_de = cloud_de_de;
